/* One shared brightness check for product labels, including AJAX-loaded cards. */
(() => {
  if (window.ornataProductCardBrightness) return;
  window.ornataProductCardBrightness = true;
  const watched = new WeakSet();

  function watch(card, role) {
    const image = card.querySelector(`.product-card__image--${role}`);
    if (!image || watched.has(image)) return;
    watched.add(image);
    const attribute = `data-${role}-bright`;
    let analyzedSource;
    function update() {
      if (!card.isConnected || !image.complete) return;
      const source = image.currentSrc || image.src;
      if (source === analyzedSource) return;
      analyzedSource = source;
      let brightness = "light";
      if (image.naturalWidth && image.naturalHeight) {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = canvas.height = 50;
          const context = canvas.getContext("2d", { willReadFrequently: true });
          context.drawImage(
            image,
            image.naturalWidth * 0.75,
            0,
            image.naturalWidth * 0.25,
            image.naturalHeight * 0.25,
            0,
            0,
            50,
            50,
          );
          const { data } = context.getImageData(0, 0, 50, 50);
          let sum = 0;
          for (let i = 0; i < data.length; i += 4)
            sum +=
              data[i + 3] < 128
                ? 255
                : 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
          if (sum / (data.length / 4) < 160) brightness = "dark";
        } catch (_) {
          /* Keep readable default labels if pixels are unavailable. */
        }
      }
      if (card.getAttribute(attribute) !== brightness)
        card.setAttribute(attribute, brightness);
    }
    image.addEventListener("load", update);
    image.addEventListener("error", update);
    if (image.complete) update();
  }

  function scan(root) {
    if (!(root instanceof Element) && root !== document) return;
    const cards = root.matches?.("product-card") ? [root] : [];
    const parentCard = root.closest?.("product-card");
    if (parentCard) cards.push(parentCard);
    cards.push(...root.querySelectorAll("product-card"));
    for (const card of cards) {
      watch(card, "primary");
      watch(card, "secondary");
    }
  }

  function start() {
    scan(document);
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations)
        for (const node of mutation.addedNodes) scan(node);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("shopify:section:load", (event) =>
      scan(event.target),
    );
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", start, { once: true });
  else start();
})();
